import { Card, CardContent, Checkbox, List, ListItem, ListItemText } from "@mui/material";
import CardHeaderColor from "components/MuiExtras/Card/CardHeaderColor";
import { getTranslatedSystemRoles } from "lib/TranslationUtils";
import { SystemRoles } from "models/ApiEnums";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
}

interface IProps {
    ownRoles: SystemRoles;
    groupsRoles: SystemRoles;
    onChange: (v: SystemRoles) => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class GroupEditRole extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { dialog: null };
    }

    ///
    private handlePermission(role: SystemRoles) {
        const { ownRoles, onChange } = this.props;

        if ((ownRoles & role) == 0)
            onChange(ownRoles | role);
        else
            onChange(ownRoles ^ role);
    }

    ///
    public render() {

        const { ownRoles, groupsRoles } = this.props;

        var roles = getTranslatedSystemRoles();//.sort((a, b) => a.value.localeCompare(b.value));

        return (
            <>
                {this.state.dialog}
                <Card>
                    <CardHeaderColor color="primary" title={this.props.t("Views.Group.Components.GroupEditRole.HeaderTitle")} />

                    <CardContent>
                        <List>
                            {
                                roles
                                    .filter(p =>
                                        p.key != SystemRoles.None
                                        && p.key != SystemRoles.All
                                        && (p.key != SystemRoles.Administrator || Session.hasRole(SystemRoles.Administrator))
                                    )
                                    .map(role => {

                                        const inherit = (groupsRoles & role.key) > 0;
                                        const hasOwnRole = (ownRoles & role.key) > 0;
                                        return (
                                            <ListItem
                                                key={role.key}
                                                dense
                                                disableGutters
                                            >
                                                <Checkbox
                                                    checked={inherit || hasOwnRole}
                                                    disabled={inherit}
                                                    onClick={() => this.handlePermission(role.key)}
                                                    style={{ padding: 0 }}
                                                />
                                                <ListItemText
                                                    primary={role.value}
                                                    secondary={inherit ? this.props.t("Views.Group.Components.GroupEditRole.InheritText") : null}
                                                />
                                            </ListItem>
                                        );
                                    })
                            }
                        </List>
                    </CardContent>

                </Card>
            </>
        );
    }
}

export default withTranslation()(GroupEditRole);